(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-card/assets/javascripts/draw-card-variants/draw-card-small.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-card/assets/javascripts/draw-card-variants/draw-card-small.js');
"use strict";


const ReactButton = svs.ui.ReactButton;
const clx = svs.components.lbUtils.clx;
const _svs$components$tipse = svs.components.tipsen.drawCard,
  DrawCard = _svs$components$tipse.DrawCard,
  useConditionalWrapper = _svs$components$tipse.useConditionalWrapper;
const _svs$components$tipse2 = svs.components.tipsen.drawCard.constants,
  DRAW_CARD_TITLES = _svs$components$tipse2.DRAW_CARD_TITLES,
  DRAW_CARD_ICON_SIZE = _svs$components$tipse2.DRAW_CARD_ICON_SIZE,
  DRAW_STATE = _svs$components$tipse2.DRAW_STATE,
  DRAW_STATE_TEXTS = _svs$components$tipse2.DRAW_STATE_TEXTS;
const DisabledOverlay = svs.components.tipsen.drawCard.components.DisabledOverlay;
const _svs$ui$ReactSpeechBu = svs.ui.ReactSpeechBubble,
  SpeechBubble = _svs$ui$ReactSpeechBu.SpeechBubble,
  SpeechBubbleSport3 = _svs$ui$ReactSpeechBu.SpeechBubbleSport3;
const productIds = svs.utils.products.productIds;
const currencyFromJupiterString = svs.utils.format.CurrencyFromJupiterString;
const formatDate = svs.components.lbUtils.helpers.formatDate.formatDate;
const hasReactChildren = children => {
  if (Array.isArray(children)) {
    return children.some(child => Boolean(child));
  }
  return Boolean(children);
};
const DrawCardSmallSection = _ref => {
  let children = _ref.children,
    className = _ref.className,
    ariaLabel = _ref.ariaLabel,
    hasHiddenAria = _ref.hasHiddenAria;
  if (!hasReactChildren(children)) {
    return null;
  }
  return React.createElement("div", {
    "aria-hidden": Boolean(hasHiddenAria),
    "aria-label": ariaLabel,
    className: clx('pg_draw_card_small__section', className)
  }, children);
};
const BetEventsSection = _ref2 => {
  let betEvents = _ref2.betEvents,
    isListItem = _ref2.isListItem;
  return React.createElement(DrawCardSmallSection, {
    className: "pg_draw_card_small__section--footer pg_draw_card_small__section--bet-events grid-span-2-cols",
    hasHiddenAria: !isListItem
  }, React.createElement(DrawCard.BetEvents, {
    hasScrolling: true
  }, betEvents));
};
const DrawCardSmall = _ref3 => {
  var _renderDate$charAt;
  let branding = _ref3.branding,
    className = _ref3.className,
    competitionDrawNumber = _ref3.competitionDrawNumber,
    extraMoney = _ref3.extraMoney,
    _ref3$icon = _ref3.icon,
    icon = _ref3$icon === void 0 ? 'game-soccer' : _ref3$icon,
    _ref3$isListItem = _ref3.isListItem,
    isListItem = _ref3$isListItem === void 0 ? false : _ref3$isListItem,
    league = _ref3.league,
    netSale = _ref3.netSale,
    onToggleDrawSelector = _ref3.onToggleDrawSelector,
    isSelected = _ref3.isSelected,
    betEvents = _ref3.betEvents,
    regCloseTime = _ref3.regCloseTime,
    _ref3$shouldShowChang = _ref3.shouldShowChangeDrawButton,
    shouldShowChangeDrawButton = _ref3$shouldShowChang === void 0 ? false : _ref3$shouldShowChang,
    state = _ref3.state,
    titleElement = _ref3.titleElement,
    uniqueId = _ref3.uniqueId,
    productId = _ref3.productId;
  const ConditionalDisabledOverlayWrapper = useConditionalWrapper(DisabledOverlay, {
    skip: state !== DRAW_STATE.TEMPORARY_CLOSED
  });
  const isBombenOrMatchen = productId === productIds.MATCHEN || productId === productIds.BOMBEN;
  const extraMoneyOptions = React.useMemo(() => [{
    displayCondition: extraMoney === null || extraMoney === void 0 ? void 0 : extraMoney.isExtraMoney,
    title: DRAW_CARD_TITLES.EXTRA_MONEY
  }, {
    displayCondition: extraMoney === null || extraMoney === void 0 ? void 0 : extraMoney.isRolloverIn,
    title: DRAW_CARD_TITLES.ROLL_OVER_IN
  }, {
    displayCondition: extraMoney === null || extraMoney === void 0 ? void 0 : extraMoney.isJackpot,
    title: DRAW_CARD_TITLES.JACKPOT
  }], [extraMoney === null || extraMoney === void 0 ? void 0 : extraMoney.isExtraMoney, extraMoney === null || extraMoney === void 0 ? void 0 : extraMoney.isJackpot, extraMoney === null || extraMoney === void 0 ? void 0 : extraMoney.isRolloverIn]);
  const blockName = 'pg_draw_card_small';
  const classNames = clx(blockName, {
    'pg_draw_card--selected': isSelected,
    'pg_draw_card_small--list-item': isListItem
  }, className);
  const shouldShowSpeechBubble = Boolean((extraMoney === null || extraMoney === void 0 ? void 0 : extraMoney.isExtraMoney) && isListItem);
  const headerSectionClassName = clx('pg_draw_card_small__section--header', shouldShowSpeechBubble && 'pg_draw_card_small__section--header_with_speech_bubble', 'pg_draw_card_small__section--content');
  const date = new Date(regCloseTime);
  const isValidDate = !isNaN(date);
  const renderDate = isValidDate ? formatDate(regCloseTime, true, true, false) : regCloseTime;
  const renderDataCapitalized = (renderDate === null || renderDate === void 0 || (_renderDate$charAt = renderDate.charAt(0)) === null || _renderDate$charAt === void 0 ? void 0 : _renderDate$charAt.toUpperCase()) + (renderDate === null || renderDate === void 0 ? void 0 : renderDate.slice(1));
  return React.createElement(ConditionalDisabledOverlayWrapper, null, React.createElement(DrawCard, {
    branding: branding,
    className: classNames
  }, React.createElement(DrawCardSmallSection, {
    ariaLabel: "Omg\xE5ng: ".concat(titleElement),
    className: headerSectionClassName
  }, React.createElement(DrawCard.Title, {
    hasHiddenAria: true,
    icon: icon,
    iconSize: DRAW_CARD_ICON_SIZE.SMALL,
    isSelected: isSelected
  }, titleElement), shouldShowSpeechBubble && React.createElement(SpeechBubble, {
    className: "pg_draw_card_speech_bubble",
    size: "100"
  }, React.createElement(SpeechBubbleSport3, null, "".concat(DRAW_CARD_TITLES.EXTRA_MONEY, ": ").concat(extraMoney.amount))), !isBombenOrMatchen && React.createElement(DrawCard.League, {
    className: shouldShowSpeechBubble ? 'pg_draw_card_small__section--header_league' : '',
    hasHiddenAria: true
  }, league)), React.createElement(DrawCardSmallSection, {
    className: "pg_draw_card_small__section--body"
  }, isBombenOrMatchen && React.createElement("div", {
    "aria-hidden": true,
    className: "pg_draw_card_small__section--content"
  }, React.createElement("div", null, DRAW_CARD_TITLES.LEAGUE), React.createElement(DrawCard.League, null, league)), competitionDrawNumber > 0 && React.createElement("div", {
    "aria-label": "".concat(DRAW_CARD_TITLES.DRAW_DESCRIPTION, ": ").concat(competitionDrawNumber),
    className: "pg_draw_card_small__section--content"
  }, React.createElement("div", {
    "aria-hidden": true
  }, DRAW_CARD_TITLES.DRAW_DESCRIPTION), React.createElement(DrawCard.CompetitionDrawNumber, {
    hasHiddenAria: true
  }, competitionDrawNumber)), regCloseTime && state !== DRAW_STATE.CANCELLED && React.createElement("div", {
    "aria-label": "".concat(DRAW_CARD_TITLES.BET_STOP, ": ").concat(renderDataCapitalized),
    className: "pg_draw_card_small__section--content"
  }, React.createElement("div", {
    "aria-hidden": true
  }, DRAW_CARD_TITLES.BET_STOP), React.createElement(DrawCard.RegCloseTime, {
    hasHiddenAria: true
  }, regCloseTime)), state === DRAW_STATE.NOT_OPENED && React.createElement("div", {
    "aria-label": "".concat(DRAW_CARD_TITLES.STATE, ": ").concat(DRAW_STATE_TEXTS.NOT_OPENED),
    className: "pg_draw_card_small__section--content"
  }, React.createElement("div", {
    "aria-hidden": true
  }, DRAW_CARD_TITLES.STATE), React.createElement(DrawCard.Status, {
    hasHiddenAria: true
  }, DRAW_STATE_TEXTS.NOT_OPENED)), state === DRAW_STATE.CANCELLED && React.createElement("div", {
    "aria-label": "".concat(DRAW_CARD_TITLES.STATE, ": ").concat(DRAW_STATE_TEXTS.CANCELLED),
    className: "pg_draw_card_small__section--content"
  }, React.createElement("div", {
    "aria-hidden": true
  }, DRAW_CARD_TITLES.STATE), React.createElement(DrawCard.Status, {
    hasHiddenAria: true,
    isCancelled: true
  }, DRAW_STATE_TEXTS.CANCELLED)), netSale && React.createElement("div", {
    "aria-label": "".concat(DRAW_CARD_TITLES.NET_SALE, ": ").concat(currencyFromJupiterString(netSale), " kronor"),
    className: "pg_draw_card_small__section--content"
  }, React.createElement("div", {
    "aria-hidden": true
  }, DRAW_CARD_TITLES.NET_SALE), React.createElement(DrawCard.NetSale, {
    currencyCounterUniqueId: uniqueId,
    hasHiddenAria: true
  }, netSale)), extraMoneyOptions.map(extraMoneyOption => extraMoneyOption.displayCondition && React.createElement("div", {
    "aria-label": "".concat(extraMoneyOption.title, ": ").concat(extraMoney.amount),
    className: "pg_draw_card_small__section--content",
    key: extraMoneyOption.title
  }, React.createElement("div", {
    "aria-hidden": true
  }, extraMoneyOption.title), React.createElement(DrawCard.ExtraAmount, {
    hasHiddenAria: true
  }, extraMoney.amount))), (extraMoney === null || extraMoney === void 0 ? void 0 : extraMoney.isExtraMoneyAndJackpot) && React.createElement("div", {
    "aria-label": "".concat(DRAW_CARD_TITLES.EXTRA_MONEY, ": ").concat(extraMoney.amountForExtraMoneyWithJackpot),
    className: "pg_draw_card_small__section--content"
  }, React.createElement("div", {
    "aria-hidden": true
  }, DRAW_CARD_TITLES.EXTRA_MONEY), React.createElement(DrawCard.ExtraAmount, {
    hasHiddenAria: true
  }, extraMoney.amountForExtraMoneyWithJackpot))), (extraMoney === null || extraMoney === void 0 ? void 0 : extraMoney.isGuaranteeJackpot) && React.createElement(DrawCardSmallSection, {
    className: "pg_draw_card_small__section--center pg_draw_card_component"
  }, "En ensam vinnare \xE4r garanterad ".concat(extraMoney.amount, " kr")), React.createElement(BetEventsSection, {
    betEvents: betEvents,
    isListItem: isListItem
  }), React.createElement(DrawCardSmallSection, {
    className: "pg_draw_card_small__section--footer grid-span-2-cols pg_draw_card_section--exclude-from-overlay"
  }, shouldShowChangeDrawButton && onToggleDrawSelector && React.createElement(DrawCard.ChangeDraw, null, React.createElement(ReactButton, {
    block: true,
    inverted: true,
    onClick: onToggleDrawSelector,
    size: 300
  }, "Byt omg\xE5ng"))), isListItem && React.createElement(DrawCard.DrawToggleBtn, {
    className: "pg_draw_card_horizontal_list_item__change_draw_btn",
    isSelected: isSelected,
    isSmallDrawCard: true
  })));
};
setGlobal('svs.components.tipsen.drawCard.DrawCardSmall', DrawCardSmall);

 })(window);